import {GET_HIRE_DECISION_LIST, GET_HIRE_DECISION_LIST_SUCCESS, GET_HIRE_DECISION_LIST_FAILED} from './actionType'



const initialState = {
   loading: false,
   hiredDecisionData: null ,
   errorMessage: null
   
}

const hireDecisionReducer = (state = initialState, action) => {

  switch (action.type) {
    case GET_HIRE_DECISION_LIST:
      state = {
        ...state,
        loading: true,
        hiredDecisionData: null ,
        errorMessage: null
      }
      break
    case GET_HIRE_DECISION_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        hiredDecisionData: action.payload ,
        errorMessage: null
      }
      break
    case GET_HIRE_DECISION_LIST_FAILED:

      state = {
        ...state,
        loading: false,
        hiredDecisionData: null ,
        errorMessage: action.payload
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default hireDecisionReducer
